/**
 * Exports a simple set of classes to apply to your own LinkTo. This is to avoid needing to replicate the interface of a
 * LinkTo component, or to allow for use of a standard <a> tag
 */
export const linkClassNames = 'text-blue-350 text-sm font-semibold hover:text-blue-400'
